// extracted by mini-css-extract-plugin
module.exports = {"container":"SettingsContent_container__1RbKN","marker":"SettingsContent_marker__14iqy","text":"SettingsContent_text__3zOM1","iconButton":"SettingsContent_iconButton__1Tkbv"};